import React, { useState } from "react";
// import { CycleTATIcon } from "../../../../CommonComponents/assets/commonassets/CommonAssets";
import SterilizationProcessingAddToStock from "./addToStock/SterilizationProcessingAddToStock";
import SterilizationProcessingCompleted from "./completed/SterilizationProcessingCompleted";
import SterilizationProcessingOnGoing from "./onGoing/SterilizationProcessingOnGoing";
import PendingSterilizationProcessing from "./pending/PendingSterilizationProcessing";
import { Tooltip } from "@mui/material";
import CSSDTATDetails from "../cssdCycleDetails/CSSDTATDetails";

function SterilizationProcessing() {
  const stages = [
    {
      name: "Pending",
      fill: "#FCFFDE",
      stroke: "#DDCD7A",
      textFill: "#B5A72C",
    },
    {
      name: "Ongoing",
      fill: "#F8D8CA",
      stroke: "#FFB392",
      textFill: "#FF6927",
    },
    {
      name: "Completed",
      fill: "#DFF6DD",
      stroke: "#7ACA68",
      textFill: "#2E7D32",
    },
    {
      name: "Add to Stock",
      fill: "#FFFAFF",
      stroke: "#942C90",
      textFill: "#942C90",
    },
  ];

  const [selectedStage, setSelectedStage] = useState("Pending");
  const [openCSSDCycleDetailsModal, setOpenCSSDCycleDetailsModal] =
    useState(false);

  return (
    <div className="relative">
      <div className="flex justify-between items-center">
        <div className="flex items-center px-4">
          {stages.map((option, index) => (
            <button type="button" onClick={() => setSelectedStage(option.name)}>
              <svg
                key={option.name}
                width="128"
                height="40"
                viewBox="0 0 178 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d={
                    index === 0
                      ? "M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H157.319L172.567 16.1635C174.646 18.2988 174.646 21.7012 172.567 23.8365L157.319 39.5H6.00001C2.96244 39.5 0.5 37.0376 0.5 34V20V6Z"
                      : "M4.16421 3.10991C3.14971 2.18764 3.80217 0.5 5.17321 0.5H158.21L173.533 16.1524C175.627 18.2904 175.627 21.7095 173.533 23.8476L158.21 39.5H5.17322C3.80217 39.5 3.14972 37.8124 4.16421 36.8901L19.0806 23.3297C21.0446 21.5443 21.0446 18.4557 19.0806 16.6703L4.16421 3.10991Z"
                  }
                  fill={option.name === selectedStage ? "#073763" : option.fill}
                  stroke={
                    option.name === selectedStage ? "#073763" : option.stroke
                  }
                />
                <text
                  x="50%"
                  y="50%"
                  dominantBaseline="middle"
                  textAnchor="middle"
                  fontSize="16"
                  fontFamily="Arial"
                  fontWeight="600"
                  fill={
                    option.name === selectedStage ? "#fff" : option.textFill
                  }
                >
                  {option.name}
                </text>
              </svg>
            </button>
          ))}
        </div>
        {(selectedStage === "Completed" || selectedStage == "Add to Stock") && (
          <Tooltip title="CSSD Cycle Details">
            <button
              type="button"
              onClick={() => {
                setOpenCSSDCycleDetailsModal(true);
              }}
            >
              {/* <CycleTATIcon /> */}
            </button>
          </Tooltip>
        )}
      </div>
      {(selectedStage == "Pending" && (
        <PendingSterilizationProcessing setSelectedStage={setSelectedStage} />
      )) ||
        (selectedStage == "Ongoing" && (
          <SterilizationProcessingOnGoing setSelectedStage={setSelectedStage} />
        )) ||
        (selectedStage == "Completed" && (
          <SterilizationProcessingCompleted
            setSelectedStage={setSelectedStage}
          />
        )) ||
        (selectedStage == "Add to Stock" && (
          <SterilizationProcessingAddToStock />
        ))}
      {openCSSDCycleDetailsModal && (
        <CSSDTATDetails
          openCSSDCycleDetailsModal={openCSSDCycleDetailsModal}
          setOpenCSSDCycleDetailsModal={setOpenCSSDCycleDetailsModal}
        />
      )}
    </div>
  );
}

export default SterilizationProcessing;